"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionType = exports.LocalStorageSettingsKey = exports.ASBonusPickOptions = exports.WINTYPE = exports.ASMainGamePickOptions = void 0;
var ASMainGamePickOptions;
(function (ASMainGamePickOptions) {
    ASMainGamePickOptions["VOLATILITY"] = "VOLATILITY";
    ASMainGamePickOptions["BOOSTED_BET"] = "BOOSTED_BET";
})(ASMainGamePickOptions = exports.ASMainGamePickOptions || (exports.ASMainGamePickOptions = {}));
var WINTYPE;
(function (WINTYPE) {
    WINTYPE["NORMAL"] = "NORMAL";
    WINTYPE["MULTIPLIER"] = "MULTIPLIER";
})(WINTYPE = exports.WINTYPE || (exports.WINTYPE = {}));
var ASBonusPickOptions;
(function (ASBonusPickOptions) {
    ASBonusPickOptions["PICK_MODE"] = "pickMode";
    ASBonusPickOptions["ROW_OPTIONS"] = "rowOptions";
})(ASBonusPickOptions = exports.ASBonusPickOptions || (exports.ASBonusPickOptions = {}));
var LocalStorageSettingsKey;
(function (LocalStorageSettingsKey) {
    LocalStorageSettingsKey["AS_STOP_ON_BONUS"] = "AS_STOP_ON_BONUS";
    LocalStorageSettingsKey["AS_BONUS_TAB_SELECTED"] = "AS_BONUS_TAB_SELECTED";
})(LocalStorageSettingsKey = exports.LocalStorageSettingsKey || (exports.LocalStorageSettingsKey = {}));
var OptionType;
(function (OptionType) {
    OptionType["MAIN_GAME"] = "mainGame";
    OptionType["BONUS_GAME"] = "bonusGame";
})(OptionType = exports.OptionType || (exports.OptionType = {}));
//# sourceMappingURL=ASEnums.js.map